import { render, staticRenderFns } from "./KBAutocomplete.vue?vue&type=template&id=09c913ae&scoped=true&"
import script from "./KBAutocomplete.vue?vue&type=script&lang=js&"
export * from "./KBAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./KBAutocomplete.vue?vue&type=style&index=0&id=09c913ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c913ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
